import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { handleItemClick } from './services/handleItemClick';
import { handleIconClick } from './services/handleIconClick';

const ContextItem = ({ context, currentDataID }) => {
  const { t } = useTranslation();
  const isDisabled = context.disabled;
  const hasCount = context.count > 0;

  return (
    <div
      className={`flex justify-between items-center px-4 py-2 hover:bg-gray-100 ${
        isDisabled ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer'
      }`}
      onClick={(e) => !isDisabled && handleItemClick(e, context, currentDataID)}
    >
      {/* Left Side: Icon + Label */}
      <div className="flex items-center space-x-2 text-gray-500">
        {context.icon.name && (
          <span className={`e-icons e-${context.icon.name} text-base`} />
        )}
        <span>{t(context.label)}</span>
      </div>

      {/* Right Side: Action Buttons + Counter */}
      <div className="flex items-center gap-1">
        {context.menu?.elements?.map((element) => (
          <button
            key={`btn-${element.id}-${Math.random()}`}
            className={`w-6 h-6 flex items-center justify-center border border-gray-300 rounded-full bg-white hover:bg-gray-300 ${
              element.disabled || isDisabled ? 'opacity-50 cursor-not-allowed' : ''
            }`}
            disabled={element.disabled || isDisabled}
            onClick={(e) => {
              e.stopPropagation(); 
              if (!element.disabled && !isDisabled) {
                handleIconClick(element, e, currentDataID);
              }
            }}
          >
            <span
              className={`e-icons e-${element.icon.name} text-xs`}
              style={{ cursor: isDisabled ? 'default' : 'pointer' }}
            />
          </button>
        ))}

        {/* Counter */}
        <span
          className={'text-[13px] font-normal rounded-md px-[6px] min-w-[21px] h-[21px] ml-[3px] flex items-center justify-center text-xs'}
          style={{
            backgroundColor: hasCount ? 'var(--secondaryColor)' : '#f0f0f0',
            color: hasCount ? 'var(--secondaryContrast)' : '#9b9c9b',
          }}
        >
          {context.count}
        </span>
      </div>
    </div>
  );
};

ContextItem.propTypes = {
  context: PropTypes.object,
  currentDataID: PropTypes.any,
};

export default ContextItem;
